import { Injector, runInInjectionContext } from '@angular/core';
import { AccOverviewData } from '@features/social-analysis/social-listening/models/I-account-overview';
import { AccOverviewHttpBuilder } from '@features/social-analysis/social-listening/services/acc-over.http';
import { PageFiltersState } from './page-filters.store';
import { BaseState } from './state.store';

export class AccOverview extends BaseState<AccOverviewData> {
    #http!: AccOverviewHttpBuilder;

    constructor(injector: Injector) {
        super();
        runInInjectionContext(injector, () => (this.#http = new AccOverviewHttpBuilder()));
    }

    reqData(pageFilters: PageFiltersState, igAcc: string) {
        this.#http.reqData(this, pageFilters, igAcc);
    }
}
